/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions */
import { ArrowRight } from "lucide-react";

import { careerStory } from "./career-story";

export const ProblemSection = () => (
  <section id="why" className="folio-problem">
    <div className="folio-shell">
      <div className="folio-problem-heading">
        <p className="folio-eyebrow">A line can only say so much</p>
        <h2>
          The bullet point is true.
          <br />
          The story goes deeper.
        </h2>
      </div>
      <div className="folio-comparison">
        <div>
          <span className="folio-label">What the resume says</span>
          <p>“{careerStory.statement}”</p>
        </div>
        <ArrowRight className="folio-comparison-arrow" size={26} aria-hidden="true" />
        <div>
          <span className="folio-label">What Avery can tell you</span>
          <p>“{careerStory.intro}”</p>
        </div>
      </div>
      <p className="folio-example-note">An illustrative story, followed through this page.</p>
    </div>
  </section>
);
